import ReplayIcon from '@mui/icons-material/Replay';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useLocation } from 'react-router-dom';

import { ButtonLink } from '../ButtonLink/ButtonLink';

interface ErrorDetails {
    message: string;
    code?: string;
    response?: {
        data?: {
            error?: string;
            reason?: string;
            result: string;
        };
    };
}

interface GlobalErrorProps {
    error: ErrorDetails;
    translations: Record<string, string>;
}

export const GlobalError: React.FC<GlobalErrorProps> = ({ error, translations }) => {
    const currentLocation = useLocation();

    const reloadWindow = (event: React.MouseEvent) => {
        event.preventDefault();
        window.location.reload();
    };

    const buttonLinkProps = currentLocation?.pathname === '/' ? { onClick: reloadWindow } : { to: '/' };

    const reloadButton = (
        <Button
            fullWidth
            disableElevation
            variant="contained"
            size="large"
            startIcon={<ReplayIcon />}
            onClick={reloadWindow}
        >
            {translations.GLOBAL_RELOAD_BUTTON}
        </Button>
    );

    return (
        <Box mx={2} mt={8}>
            <Box mb={12}>
                <Typography variant="h4">{translations.GLOBAL_ERROR_TITLE}</Typography>
                <Typography variant="subtitle2">{error.response?.data?.error ?? error.message}</Typography>

                {error.code === 'ECONNABORTED' && <Box my={4}>{reloadButton}</Box>}
            </Box>
            {error.message === 'Request failed with status code 500' ? (
                // TODO support french by using keys and discuss the content of the messages
                <>
                    <Typography variant="subtitle1">{translations.UNEXPECTED_ERROR_OCCURED}</Typography>
                    <Typography variant="subtitle2">{translations.ERROR_500_HELP_HEADER}</Typography>
                    <List>
                        <ListItem>{translations.ERROR_500_HELP_ACTION_REFRESH}</ListItem>
                        <ListItem>{translations.ERROR_500_HELP_ACTION_REOPEN}</ListItem>
                        <ListItem>{translations.ERROR_500_HELP_ACTION_RELAUNCH}</ListItem>
                        <ListItem>{translations.ERROR_500_HELP_ACTION_CONTACT_US}</ListItem>
                    </List>
                    {reloadButton}
                </>
            ) : (
                <ButtonLink {...buttonLinkProps} text={translations.GLOBAL_HOME_BUTTON} />
            )}
        </Box>
    );
};
